<template>
  <v-list subheader>
    <v-subheader>Sale</v-subheader>

    <v-list-item @click="openDateSelector('sale/byProduct')">
      <v-list-item-avatar tile>
        <v-img src="@/assets/Report/barcode.png"></v-img>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title>Sale By Product</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-divider inset></v-divider>
    <v-list-item @click="openDateSelector('sale/bySalesman')">
      <v-list-item-avatar tile>
        <v-img src="@/assets/Report/communications.png"></v-img>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title>Sale By Reps</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-divider inset></v-divider>
    <v-list-item @click="openDateSelector('sale/byCustomers')">
      <v-list-item-avatar tile>
        <v-img src="@/assets/Report/communications.png"></v-img>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title>Sale By Customers</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
import { mapActions } from "vuex";

export default {
  methods: {
    ...mapActions("reportView", ["setDateSelector", "setReportName"]),
    openReport(link) {
      let routeData = this.$router.resolve({
        path: `/reportView/invoice/${link}`,
      });
      window.open(routeData.href, "_blank");
    },
    openDateSelector(val) {
      this.setReportName(val);
      this.setDateSelector(true);
    },
  },
};
</script>

<style scoped></style>
